export const API_BASE_URL = String(process.env.REACT_APP_API_URL || "").trim();

export const LOGIN_PATIENT_PATH = "/login/paciente";
export const LOGIN_INTERNAL_PATH = "/login/interno";
export const START_PATH = "/inicio";

export const buildExpiredSessionLoginPath = () => `${LOGIN_PATIENT_PATH}?expired=1`;
